export const DATA_TEST_ID = {
	SELECTION_MODEL_TITLE: 'selection-model-title',
	SELECTION_STEP_TITLE: 'selection-step-title',
	SELECTION_STEP_STEPS: 'selection-step-steps',
	SELECTION_CARD_CONTAINER: 'selection-card-container',
	SELECTION_CARD_CHECKBOX: 'selection-card-checkbox',
	SELECTION_FILTER_BUTTON: 'selection-filter-button',
	SELECTION_TILE_BUTTON: 'selection-tile-button',
	SELECTION_TAB_BUTTON: 'selection-tab-button',
	SELECTION_ACCESSORIES_SEARCH_INPUT: 'selection-accessories-search-input',
	SELECTION_ACCESSORIES_CATEGORY_BUTTON: 'selection-accessories-category-button',
	SELECTION_ACCESSORIES_CATEGORY_SELECT: 'selection-accessories-category-select',
	SELECTION_ACCESSORIES_PAGINATION_BUTTON: 'selection-accessories-pagination-button',
	TACTICAL_TRIGGER: 'tactical-trigger',
	TACTICAL_CHECKBOX: 'tactical-checkbox',
	TACTICAL_MORE_INFORMATION_BUTTON: 'tactical-more-information-button',
	GALLERY_CONTAINER: 'gallery-container',
	GALLERY_3D_BUTTON: 'gallery-3d-button',
	GALLERY_ERROR_3D_BUTTON_BACK: 'gallery-error-3d-button-back',
	GALLERY_COMPARE_BUTTON: 'gallery-compare-button',
	GALLERY_FULL_SCREEN_BUTTON: 'gallery-full-screen-button',
	GALLERY_NEXT_BUTTON: 'gallery-next-button',
	GALLERY_PREVIOUS_BUTTON: 'gallery-previous-button',
	FOOTER_CONTAINER: 'footer-container',
	CAR_TITLE: 'car-title',
	TOTAL_PRICE_CONTAINER: 'price-container',
	MONTHLY_RATE_CONTAINER: 'monthly-rate-container',
	FINANCING_LAYER_BUTTON: 'financing-layer-button',
	PRICE_DETAILS_BUTTON: 'price-details-button',
	MAIN_CTA_BUTTON: 'main-cta-button',
	SUMMARY_BUTTON: 'summary-button',
	STOCK_CAR_BUTTON: 'stock-car-button',
	PRICE_BAR_BACK_BUTTON: 'price-bar-back-button',
	PRICE_BAR_CONTAINER: 'price-bar-container',
	SUMMARY_MAIN_CTA_BUTTON: 'summary-main-cta-button',
	SUMMARY_SECONDARY_CTA_BUTTON: 'summary-secondary-cta-button',
	SUMMARY_CONFIGURATION_OVERVIEW_CONTAINER: 'summary-configuration-overview-container',
	SUMMARY_CHANGE_CONFIGURATION_BUTTON: 'summary-change-configuration-button',
	SUMMARY_TECH_DATA_BUTTON: 'summary-tech-data-button',
	SUMMARY_STANDARD_EQUIPMENT_BUTTON: 'summary-standard-equipment-button',
	SUMMARY_PRICE_DETAIL_BUTTON: 'summary-price-detail-button',
	SUMMARY_EEC_CONTAINER: 'summary-eec-container',
	SUMMARY_GPSR_CONTAINER: 'summary-gpsr-container',
};
